import Vue from 'vue';
import VueAxios from 'vue-axios';
import VueAuthenticate from 'vue-authenticate';
import axios from 'axios';

Vue.use(VueAxios, axios);
Vue.use(VueAuthenticate, {
    // baseUrl: `http://${window.location.hostname}:${window.location.port}/api`, // Your API domain
    // baseUrl: `http://${window.location.hostname}/api`, // Your API domain
    baseUrl: 'api', // Your API domain
    loginUrl: 'auth.login',
    signupUrl: 'auth.signup',
    unlinkUrl: 'auth.unlink',
    tokenName: 'token',
    tokenPrefix: 'auth',

    providers: {
        // github: {
        //     clientId: '',
        //     redirectUri: 'http://localhost:8080/auth/callback' // Your client app URL
        // }
    }
});
